import { render } from "./CustomSidebar.vue?vue&type=template&id=0c09c576&scoped=true"
import script from "./CustomSidebar.vue?vue&type=script&lang=js"
export * from "./CustomSidebar.vue?vue&type=script&lang=js"

import "./CustomSidebar.vue?vue&type=style&index=0&id=0c09c576&lang=css&scoped=true"

import exportComponent from "/Users/numeria/Desktop/innopearl-partner-plus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c09c576"]])

export default __exports__